import Duck from 'extensible-duck';

export const OVOAuthState = {
  Pending: 'PENDING',
  Success: 'SUCCESS',
  Failure: 'FAILURE',
};

export default new Duck({
  namespace: 'GEWEB',
  store: 'OVO',
  types: [
    'START_AUTH',
    'SET_MFA_DETAILS',
    'SUBMIT_AUTH_CODE',
    'AUTH_SUCCESS',
    'AUTH_FAILURE',
    'AUTH_CANCEL',
    'RESET_ALL',
  ],
  creators: duck => ({
    startAuth: (txnID, deliveryID) => ({
      type: duck.types.START_AUTH,
      txnID,
      deliveryID,
    }),
    setMFADetails: (MFAURL, termURL) => ({
      type: duck.types.SET_MFA_DETAILS,
      MFAURL,
      termURL,
    }),
    submitAuthCode: authCode => ({
      type: duck.types.SUBMIT_AUTH_CODE,
      authCode,
    }),
    authSuccess: () => ({ type: duck.types.AUTH_SUCCESS }),
    authCancel: () => ({ type: duck.types.AUTH_CANCEL }),
    resetAll: () => ({ type: duck.types.RESET_ALL }),
  }),
  initialState: {
    authState: OVOAuthState.Pending,
    deliveryID: undefined,
    txnID: undefined,
    MFAURL: undefined,
    termURL: undefined,
    authCode: undefined,
  },
  reducer: (state, action, duck) => {
    switch (action.type) {
      case duck.types.START_AUTH: {
        const { txnID, deliveryID } = action;
        return {
          ...state,
          txnID,
          deliveryID,
        };
      }
      case duck.types.SET_MFA_DETAILS: {
        const { MFAURL, termURL } = action;
        return {
          ...state,
          MFAURL,
          termURL,
        };
      }
      case duck.types.SUBMIT_AUTH_CODE: {
        const { authCode } = action;
        return {
          ...state,
          authCode,
        };
      }
      case duck.types.AUTH_SUCCESS: {
        return {
          ...state,
          authState: OVOAuthState.Success,
        };
      }
      case duck.types.RESET_ALL: {
        return duck.initialState;
      }
      default:
        return state;
    }
  },
});
